import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useMixOrderAdvisory');

    return {
        CONNECTION_ERROR: t('connectionError')
    };
};

export default useTranslation;
